import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=19392fa0&scoped=true"
import script from "./preview.vue?vue&type=script&lang=js"
export * from "./preview.vue?vue&type=script&lang=js"
import style0 from "./preview.vue?vue&type=style&index=0&id=19392fa0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19392fa0",
  null
  
)

export default component.exports